import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b81d69e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b81d69e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81d69e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InlineLoader: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/InlineLoader.vue').default,InternationalPhoneInputSelect: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/InternationalPhoneInputSelect.vue').default,Consents: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Consents.vue').default})
